import { useMemo } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import type { RouterProviderProps } from 'react-router-dom';
import { routes } from './routes';

export const createRouter = () => createBrowserRouter(routes);

export function Router(props: { router?: RouterProviderProps['router'] }) {
  const router = useMemo(() => props.router ?? createBrowserRouter(routes), [props.router]);
  return <RouterProvider router={router} />;
}
